export const CHECKOUT_LOAD_ATTEMPT = "CHECKOUT_LOAD_ATTEMPT";
export const CHECKOUT_LOAD_SUCCESS = "CHECKOUT_LOAD_SUCCESS";
export const CHECKOUT_LOAD_FAILED = "CHECKOUT_LOAD_FAILED";
